import React from 'react';

/**
 * Microphone icon component
 * Displays microphone icon to indicate listening state
 */
const MicIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg 
    width="14" 
    height="20" 
    viewBox="0 0 14 20" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path 
      d="M12.8346 8.33301V9.99967C12.8346 11.5468 12.2201 13.0305 11.1261 14.1245C10.0321 15.2184 8.5484 15.833 7.0013 15.833M7.0013 15.833C5.45421 15.833 3.97047 15.2184 2.87651 14.1245C1.78255 13.0305 1.16797 11.5468 1.16797 9.99967V8.33301M7.0013 15.833V19.1663M3.66797 19.1663H10.3346M7.0013 0.833008C6.33826 0.833008 5.70238 1.0964 5.23353 1.56524C4.76469 2.03408 4.5013 2.66997 4.5013 3.33301V9.99967C4.5013 10.6627 4.76469 11.2986 5.23353 11.7674C5.70238 12.2363 6.33826 12.4997 7.0013 12.4997C7.66434 12.4997 8.30023 12.2363 8.76907 11.7674C9.23791 11.2986 9.5013 10.6627 9.5013 9.99967V3.33301C9.5013 2.66997 9.23791 2.03408 8.76907 1.56524C8.30023 1.0964 7.66434 0.833008 7.0013 0.833008Z" 
      stroke="currentColor" 
      strokeWidth="1.6" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </svg>
);

export default MicIcon;
